import type { ReactNode } from 'react';
import { BottomNav } from './BottomNav';
import { TooltipProvider } from '@/components/ui/tooltip';
import { FirstAccessTour } from '@/modules/onboarding/components/FirstAccessTour';

interface MobileShellProps {
  children: ReactNode;
}

export function MobileShell({ children }: MobileShellProps) {
  return (
    <TooltipProvider>
      <div className="flex h-dvh flex-col bg-slate-50 dark:bg-background antialiased">
        <div className="flex-1 overflow-y-auto">
          <div className="pb-20">{children}</div>
        </div>
        <BottomNav />
        <FirstAccessTour />
      </div>
    </TooltipProvider>
  );
}
